// Firebase Services stub
export interface Class {
  id: string;
  name: string;
}

export class ClassesService {
  static async getClasses() {
    // Return the exact class names from ERP's feeStructures
    // These are the only classes that have fee structures defined
    return [
      { id: '2', name: 'Nursery' },
      { id: '3', name: 'Jr.KG' },
      { id: '4', name: 'Sr.KG' },
      { id: '5', name: 'Class I' },
      { id: '6', name: 'Class II' },
      { id: '7', name: 'Class III' },
      { id: '8', name: 'Class IV' },
      { id: '9', name: 'Class V' },
      { id: '10', name: 'Class VI' },
      { id: '11', name: 'Class VII' }
    ];
  }
}
